<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <h1 class="fs-3 fw-light mb-3">Configurações do Sistema</h1>
            <generate-table [dataSource]="dataSource" [columns]="columns" [loading]="loading"></generate-table>
        </mat-card-content>
    </mat-card>
</div>